export enum PropertyLaw {
    CommunityOfAcquisitions = 'CommunityOfAcquisitions',
    CommunityOfProperty = 'CommunityOfProperty',
    SeparationOfProperty = 'SeparationOfProperty',
    Contract = 'Contract',
    NotKnown = 'NotKnown'
}
